/**
 * Extract video ID from URL (simplified version)
 */
const extractVideoId = (url) => {
    // Vimeo
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return vimeoMatch[1];

    // YouTube
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    if (youtubeMatch) return youtubeMatch[1];

    return null;
};

/**
 * Links CTAs with video URLs to their corresponding videoModule__target buttons
 * when they share the same video ID
 */
const linkVideoModules = () => {
    // Find all CTAs with video URLs
    const ctaLinks = document.querySelectorAll('.cta[href*="vimeo.com"], .cta[href*="youtube.com"], .cta[href*="youtu.be"]');

    ctaLinks.forEach(cta => {
        const ctaUrl = cta.getAttribute('href');
        if (!ctaUrl) return;

        // Extract video ID from CTA URL
        const ctaVideoId = extractVideoId(ctaUrl);
        if (!ctaVideoId) return;

        // Look for videoModule in the same container or nearby
        const container = cta.closest('.splitContent__wrapper, .container');
        if (!container) return;

        const videoModule = container.querySelector('.videoModule');
        if (!videoModule) return;

        // Check if the videoModule has matching video ID
        const iframe = videoModule.querySelector('.videoModule__videoIframe');
        const moduleVideoId = iframe ? iframe.getAttribute('data-vimeoid') : null;

        // Also check for YouTube
        const iframeSrc = iframe ? iframe.getAttribute('src') : '';
        const youtubeMatch = iframeSrc.match(/youtube\.com\/embed\/([^?]+)/);
        const moduleYouTubeId = youtubeMatch ? youtubeMatch[1] : null;

        // If video IDs match, wire up the click
        if ((moduleVideoId && ctaVideoId === moduleVideoId) ||
            (moduleYouTubeId && ctaVideoId === moduleYouTubeId)) {

            const videoTarget = videoModule.querySelector('.videoModule__target');

            if (videoTarget) {
                cta.addEventListener('click', (e) => {
                    e.preventDefault();
                    videoTarget.click();
                });
            }
        }
    });
};

// Auto-initialize when DOM is ready
if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', linkVideoModules);
    } else {
        linkVideoModules();
    }

    // Also re-run when CMS content loads (for Twill content)
    window.addEventListener('cmsContentLoaded', () => {
        // Small delay to ensure Twill content is in DOM
        setTimeout(linkVideoModules, 100);
    });
}

export default linkVideoModules;



// WEBPACK FOOTER //
// ./frontend/helpers/videoModuleLinking.js